import _defineProperty from "D:\\a\\1\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _Symbol$toPrimitive from "@babel/runtime-corejs3/core-js-stable/symbol/to-primitive";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _startsWithInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/starts-with";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$entries from "@babel/runtime-corejs3/core-js-stable/object/entries";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/index-of";
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[_Symbol$toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
import { warning, error } from '@jutro/logger';
import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from "lodash/isEmpty";
import get from "lodash/get";
import set from "lodash/set";
import { getDisplayName, wrapWithIsRequired } from './ComponentPropTypes';
export const JUTRO_WARNING_PREFIX = 'JUTRO DEPRECATION WARNING';
let warned = {};
export const oneOfWithDeprecations = (allowedItems, deprecatedItems, version) => wrapWithIsRequired((props, propName, componentName, ...rest) => {
  if (_indexOfInstanceProperty(deprecatedItems).call(deprecatedItems, props[propName]) > -1) {
    const message = `Value '${props[propName]}' assigned to ${propName} is deprecated for ${componentName}. Please consider to use one of allowed values: '${allowedItems.join(', ')}' since Jutro v${version}`;
    printDeprecationWarning({
      propName,
      componentName,
      message
    });
  }
  return PropTypes.oneOf([...deprecatedItems, ...allowedItems])(props, propName, componentName, ...rest);
});
export function deprecated(validator, droppedTargetVersion = '@next', additionalInfo = '', ...ignoredValues) {
  return (props, propName, componentName, location, propFullName, ...rest) => {
    const componentNameSafe = componentName || '<<anonymous>>';
    const propFullNameSafe = propFullName || propName;
    const propValue = propName ? props[propName] : undefined;
    if (propValue && !(ignoredValues !== null && ignoredValues !== void 0 && _includesInstanceProperty(ignoredValues).call(ignoredValues, propValue))) {
      const message = `The ${location} "${propFullNameSafe}" of "${componentNameSafe}" is deprecated. It will be removed in the "${droppedTargetVersion}" Jutro release.`;
      printDeprecationWarning({
        propName,
        componentName: componentNameSafe,
        message,
        additionalInfo
      });
    }
    return validator(props, propName, componentName, location, propFullName, ...rest);
  };
}
export function deprecateAll(validators, droppedTargetVersion = '@next', additionalInfo = '', ...ignoredValues) {
  var _context;
  return _reduceInstanceProperty(_context = _Object$entries(validators)).call(_context, (acc, [propName, validator]) => _objectSpread({}, acc, {
    [propName]: deprecated(validator, droppedTargetVersion, additionalInfo, ignoredValues)
  }), {});
}
function printDeprecationWarning({
  propName,
  componentName,
  message,
  additionalInfo
}) {
  const messageKey = `${componentName}.${propName}`;
  if (!warned[messageKey]) {
    warning(`${JUTRO_WARNING_PREFIX}: ${message} ${additionalInfo} `);
    warned[messageKey] = true;
  }
}
export function resetDeprecatedWarnings(component) {
  if (component) {
    var _context2, _context3;
    _forEachInstanceProperty(_context2 = _filterInstanceProperty(_context3 = _Object$keys(warned)).call(_context3, key => _startsWithInstanceProperty(key).call(key, `${component}.`))).call(_context2, key => delete warned[key]);
    return;
  }
  warned = {};
}
function flattenPropsInfo(propsInfo, parentKey) {
  var _context4;
  return _reduceInstanceProperty(_context4 = _Object$entries(propsInfo)).call(_context4, (accumulator, [key, value]) => {
    const type = value.type,
      name = value.name;
    let nestedProperties = {};
    if ((type === null || type === void 0 ? void 0 : type.name) === 'shape' || name === 'shape') {
      nestedProperties = flattenPropsInfo((type === null || type === void 0 ? void 0 : type.value) || value, key);
    }
    const propsKey = parentKey ? `${parentKey}.${key}` : key;
    return _objectSpread({}, accumulator, {}, nestedProperties, {
      [propsKey]: value
    });
  }, {});
}
function transformProps({
  props,
  propsInfo,
  displayName,
  transformMap,
  parentKey
}) {
  var _context5;
  return _reduceInstanceProperty(_context5 = _Object$entries(props)).call(_context5, (accumulator, [key, value]) => {
    const propKey = parentKey ? `${parentKey}.${key}` : key;
    if (!get(propsInfo, propKey)) {
      warning(`The prop "${propKey}" is not defined in the PropTypes for ${displayName}`);
      return accumulator;
    }
    const _get = get(propsInfo, propKey),
      _get$deprecationInfo = _get.deprecationInfo,
      deprecationInfo = _get$deprecationInfo === void 0 ? {} : _get$deprecationInfo,
      name = _get.name,
      type = _get.type;
    const mapTo = deprecationInfo.mapTo;
    const actualName = name || (type === null || type === void 0 ? void 0 : type.name);
    let nestedProperties = {};
    let result = _objectSpread({}, accumulator);
    const transform = get(transformMap, propKey);
    const newValue = transform ? transform(value) : value;
    if (mapTo) {
      var _context6, _newPropInfo$type;
      const omit = accumulator[propKey],
        accWithoutKey = _objectWithoutProperties(accumulator, _mapInstanceProperty(_context6 = [propKey]).call(_context6, _toPropertyKey));
      result = _objectSpread({}, accWithoutKey);
      const newPropInfo = get(propsInfo, mapTo);
      const newName = (newPropInfo === null || newPropInfo === void 0 ? void 0 : newPropInfo.name) || (newPropInfo === null || newPropInfo === void 0 ? void 0 : (_newPropInfo$type = newPropInfo.type) === null || _newPropInfo$type === void 0 ? void 0 : _newPropInfo$type.name);
      if (newName !== actualName) {
        error(`The deprecated prop "${propKey}" has been mapped to the new prop "${mapTo}" but the type does not match`);
      }
      set(result, mapTo, newValue);
    } else if (actualName === 'shape') {
      nestedProperties = transformProps({
        props: props[key],
        propsInfo,
        displayName,
        transformMap,
        parentKey: key
      });
    } else {
      set(result, propKey, newValue);
    }
    return _objectSpread({}, result, {}, nestedProperties);
  }, {});
}
export function transformDeprecatedProps(props, docgenInfo, transformMap = {}) {
  if (isEmpty(docgenInfo)) return props;
  const _docgenInfo$props = docgenInfo.props,
    propsInfo = _docgenInfo$props === void 0 ? {} : _docgenInfo$props,
    displayName = docgenInfo.displayName;
  return isEmpty(propsInfo) ? props : transformProps({
    props,
    propsInfo: flattenPropsInfo(propsInfo),
    displayName,
    transformMap
  });
}
export const withTransformedProps = (Component, transformMap = {}) => {
  const WithTransformedProps = props => {
    const transformedProps = transformDeprecatedProps(props, Component === null || Component === void 0 ? void 0 : Component.__docgenInfo, transformMap);
    return React.createElement(Component, _extends({}, props, transformedProps));
  };
  WithTransformedProps.displayName = `withTransformedProps(${getDisplayName(Component)})`;
  WithTransformedProps.WrappedComponent = Component;
  WithTransformedProps.propTypes = Component.propTypes;
  return WithTransformedProps;
};